import { ReactNode, useContext, useEffect, useState } from "react";
import Tab from "@mui/icons-material/KeyboardTab";
import DoubleArrow from "@mui/icons-material/KeyboardDoubleArrowRight";

import styles from "./main.module.scss";
import { LogOutComponent } from "./logout/logout";
import { MenuContext } from "../../../context/menuContext";
import { Popover, Tooltip } from "@mui/material";

const MenuComponent: React.FC<{
  idUser: string;
  status: boolean;
  children?: ReactNode;
}> = ({ idUser, status, children }) => {
  const { isMenuOpen, toggleMenu, userName } = useContext(MenuContext);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const userInicials = () => {
    return userName.substring(0, 2).toUpperCase();
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const displayOpenMenu = () => {
    return (
      <div
        className={isMenuOpen ? styles.menuOptions : styles.menuOptionsClose}
      >
        <div
          className={styles.menuIcon}
          role="button"
          style={{
            width: isMenuOpen ? "288px" : "70px",
            transition: "width 0.3s ease-in-out",
          }}
        >
          <div className={styles.menuIconActions} role="button" onClick={toggleMenu}>
            {isMenuOpen ? (
              <div className={styles.tooltip}>
                <Tooltip placement="left" arrow title="Cerrar barra lateral">
                  <Tab style={{ fill: "#2c2a29", rotate: '180deg' }}></Tab>
                </Tooltip>
              </div>
            ) : (
              <Tooltip placement="right" arrow title="Abrir barra lateral">
                <DoubleArrow style={{ fill: "#2c2a29" }}></DoubleArrow>
              </Tooltip>
            )}
          </div>
        </div>
        {children}
        <div className={styles.contentUserButton}>
          <Tooltip placement="top" arrow title="Menú Usuario">
            <button className={styles.newChatComponent} onClick={handleClick}>
              {userInicials()}
            </button>
          </Tooltip>
          <div
            style={{
              opacity: isMenuOpen ? "1" : "0",
              transition: "opacity .3s ease-in-out",
              width: "max-content",
            }}
          >
            <span>{userName && <span>{userName}</span>}</span>
          </div>
        </div>
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          <LogOutComponent />
        </Popover>
      </div>
    );
  };

  return displayOpenMenu();
};

export { MenuComponent };
